import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "rd_admin_token";

// Robust token storage: try localStorage first, fall back to sessionStorage
// AND a cookie (no httpOnly so the JS can read it). This protects against
// localStorage being purged by privacy extensions or strict private browsing.
function safeLocalSet(value) {
  try { localStorage.setItem(TOKEN_KEY, value); return true; } catch { return false; }
}
function safeLocalGet() {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}
function safeLocalRemove() {
  try { localStorage.removeItem(TOKEN_KEY); } catch { /* noop */ }
}
function safeSessionSet(value) {
  try { sessionStorage.setItem(TOKEN_KEY, value); return true; } catch { return false; }
}
function safeSessionGet() {
  try { return sessionStorage.getItem(TOKEN_KEY); } catch { return null; }
}
function safeSessionRemove() {
  try { sessionStorage.removeItem(TOKEN_KEY); } catch { /* noop */ }
}
function cookieSet(value) {
  // 24h max — matches backend JWT_EXPIRES_HOURS
  const expires = new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${TOKEN_KEY}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}
function cookieGet() {
  const match = document.cookie.match(new RegExp(`(?:^|; )${TOKEN_KEY}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}
function cookieRemove() {
  document.cookie = `${TOKEN_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

export const getToken = () => safeLocalGet() || safeSessionGet() || cookieGet();
export const setToken = (t) => {
  safeLocalSet(t);
  safeSessionSet(t);
  cookieSet(t);
};
export const clearToken = () => {
  safeLocalRemove();
  safeSessionRemove();
  cookieRemove();
};

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname.startsWith("/admin")) {
      clearToken();
      if (window.location.pathname !== "/admin/login") {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);
